import SFetch from '@app/utils/sfetch'
import type {
  PulseShareResponseData,
  Proposal,
  UserUpdatePayload,
} from '@app/shared/types/pulse-share'

function shareWithPulseUsersPath({
  ledgerId,
  sharedObjectId,
}: {
  ledgerId: number
  sharedObjectId: number
}): string {
  return window.Silverfin.Routes.share_ledger_company_workflow_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    ledgerId,
    sharedObjectId
  )
}

export function getPulseShareData({
  ledgerId,
  sharedObjectId,
}: {
  ledgerId: number
  sharedObjectId: number
}): Promise<PulseShareResponseData | null> {
  const path = shareWithPulseUsersPath({
    ledgerId,
    sharedObjectId,
  })
  return SFetch.json<PulseShareResponseData>(path)
}

export function getWorkflowProposalData({
  ledgerId,
  workflowId,
}: {
  ledgerId: number
  workflowId: number
}): Promise<Proposal[] | null> {
  const path =
    window.Silverfin.Routes.reconciliation_proposals_ledger_company_workflow_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId,
      ledgerId,
      workflowId
    )
  return SFetch.json<Proposal[]>(path)
}

export function shareWithPulseUsers({
  ledgerId,
  sharedObjectId,
  body,
}: {
  ledgerId: number
  sharedObjectId: number
  body: {
    users: Array<UserUpdatePayload>
    message: string | null
    blockProposals: boolean
  }
}): Promise<PulseShareResponseData | null> {
  const path = shareWithPulseUsersPath({
    ledgerId,
    sharedObjectId,
  })
  return SFetch.json<PulseShareResponseData>(path, {
    method: 'POST',
    body,
  })
}
